<template lang="pug">
  span
    button.btn.btn-danger(:disabled="disabled", type="button" @click="checkedIds.length ? modalConf = true : modalNoItem = true" title="削除" data-testid="-btn-delete-bcard"): i.fa.fa-trash

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    //- 未選択
    app-modal(v-model="modalNoItem" type="info")
      template(slot="title") 未選択
      h4 名刺を1件以上選択してください。

    //- 確認
    app-modal(v-model="modalConf" type="danger")
      template(slot="title") 確認
      h4 選択した名刺情報を削除します。よろしいですか？
      p.text-danger ※この作業は取り消すことができません。
      template(slot="footer", slot-scope="{close}")
        button.btn.btn-danger(type="submit" @click="submit") 削除
        button.btn.btn-default(type="button" @click="close") キャンセル
</template>

<script>
import AppModal from '@/components/templates/AppModal'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const BcardRepository = RepositoryFactory.get('bcard')
const ManageBcardRepository = RepositoryFactory.get('managebcard')

export default {
  name: 'FuncDelCard',
  components: { AppModal },
  props: {
    checkedIds: { type: Array, required: false, default: function () { return [] } }
  },
  data: function () {
    return {
      modalNoItem: false,
      modalConf: false
    }
  },
  computed: {
    disabled () {
      // #540 全ページ選択モードの時は利用しない
      return this.$parent.isAllPagesChecked
    }
  },
  methods: {
    submit () {
      const vm = this
      let repo = null
      let params = null

      if (this.isMgmt) {
        repo = ManageBcardRepository
        params = {
          id: this.checkedIds,
          target: 'bcard'
        }
      }
      else {
        repo = BcardRepository
        params = this.checkedIds
      }
      repo.bulkDelete(params)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.showToast('名刺情報を削除しました。', { type: 'success' })
            vm.modalConf = false
            // 一覧更新
            vm.$store.dispatch('reloadBcardList')
            // サイドメニューの件数更新
            vm.$store.dispatch('reloadSidemenu')
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '名刺情報を削除できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
        // .finally(function () {
        //   vm.modalDelete.isExec = false
        // })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/organisms/functions/FuncDelCard.vue